import { TFunction } from 'i18next'

import { DocumentType } from '@/features/documents'
import { isValidTranslationKey } from '@/utils/localisation'

const BASE_I18N_KEY = 'documents.types'

/** Build the i18n key for a given document type code */
export const getDocumentTypeTranslationKey = (dtCode: string): string => `${BASE_I18N_KEY}.${dtCode}`

/**
 * Returns the localized label for a document type code.
 *
 * Precedence:
 *  1. Translation key `documents.types.<code>` if present
 *  2. Backend provided displayName (fallback param)
 *  3. Raw code
 */
export const localizeDocumentTypeLabel = (translate: TFunction, dtCode?: string, fallback?: string): string => {
  if (!dtCode) return ''
  const key = getDocumentTypeTranslationKey(dtCode)
  return isValidTranslationKey(key) ? translate(key) : (fallback ?? dtCode)
}

/** Build a map code -> localized label */
export const buildDocumentTypeLabelMap = (
  translate: TFunction,
  documentTypes: DocumentType[]
): Record<string, string> => {
  return documentTypes.reduce<Record<string, string>>((acc, dt) => {
    acc[dt.code] = localizeDocumentTypeLabel(translate, dt.code, dt.displayName)
    return acc
  }, {})
}
